export default __webpack_public_path__ + "static/media/graphbtn.4f98f5aa.svg";